import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import React, { useState } from "react";
import { updateUserPasswordValidation } from "../../utils/validation";
import * as api from "../../redux/api";
import { toast } from "react-toastify";
import { isYupError, parseYupError } from "../../utils/Yup";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
const initialState = {
  // oldPassword: "",
  newPassword: "",
  confirmNewPassword: "",
};

const ChangeUserPassword = ({ handleClose, open, userData }) => {
  // const [eye, setEye] = useState(false);
  const [eyeNew, setEyeNew] = useState(false);
  const [eyeNew2, setEyeNew2] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [form, setForm] = useState(initialState);
  const [formError, setFormError] = useState(initialState);
  const handleCloseModal = () => {
    handleClose();
    setForm(initialState);
    setFormError({});
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({
      ...form,
      [name]: value,
    });
    setFormError({
      ...formError,
      [name]: "",
    });
  };

  const handleSubmit = async () => {
    setIsLoading(true);

    try {
      setFormError({});
      await updateUserPasswordValidation.validate(form, {
        abortEarly: false,
      });
      const res = await api.changeUserPassword({ ...form, userId: userData });
      if (res.status === 200 || res.status === 201) {
        setIsLoading(false);
        toast.success("Password Change Successfully");
        handleCloseModal();
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      if (isYupError(error)) {
        setFormError(parseYupError(error));
        setIsLoading(false);
      } else if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast.error(error.response.data.message);
      } else {
        console.log(error, "error");
        toast.error(error.message);
        setIsLoading(false);
      }

      setIsLoading(false);
    }
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleCloseModal}
        scroll={"paper"}
        fullWidth={true}
        maxWidth={"sm"}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <DialogTitle id="scroll-dialog-title">
          {" "}
          <h4 className=" text-center">Change Password</h4>
        </DialogTitle>
        <DialogContent dividers={"paper"}>
          <div>
            <div className="max-w-4xl ">
              <div className="w-full grid grid-cols-2 gap-6 mt-4">
                {/* <div>
                  <div className="input_field relative">
                    <input
                      type={eye ? "text" : "password"}
                      placeholder="Enter old password"
                      name="oldPassword"
                      onChange={handleChange}
                    />
                    <span
                      className="absolute right-4 top-[50%] translate-y-[-50%] cursor-pointer z-10"
                      onClick={() => setEye(!eye)}
                    >
                      {eye ? (
                        <AiFillEye className="text-2xl text-theme-text" />
                      ) : (
                        <AiFillEyeInvisible className="text-2xl text-theme-text" />
                      )}
                    </span>
                  </div>
                  {formError.oldPassword && (
                    <div className="form-eror">{formError.oldPassword}</div>
                  )}
                </div> */}
                <div>
                  <div className="input_field col-span-2 relative">
                    <input
                      type={eyeNew ? "text" : "password"}
                      placeholder="Enter new password"
                      name="newPassword"
                      onChange={handleChange}
                    />
                    <button
                      type="button"
                      className="absolute right-4 top-[50%] translate-y-[-50%] cursor-pointer z-10"
                      onClick={() => setEyeNew(!eyeNew)}
                    >
                      {eyeNew ? (
                        <AiFillEye className="text-2xl text-theme-text" />
                      ) : (
                        <AiFillEyeInvisible className="text-2xl text-theme-text" />
                      )}
                    </button>
                  </div>
                  {formError.newPassword && (
                    <div className="form-eror">{formError.newPassword}</div>
                  )}
                </div>
                <div>
                  <div className="input_field col-span-2 relative">
                    <input
                      type={eyeNew2 ? "text" : "password"}
                      placeholder="Confirm new password"
                      name="confirmNewPassword"
                      onChange={handleChange}
                    />
                    <button
                      type="button"
                      className="absolute right-4 top-[50%] translate-y-[-50%] cursor-pointer z-10"
                      onClick={() => setEyeNew2(!eyeNew2)}
                    >
                      {eyeNew2 ? (
                        <AiFillEye className="text-2xl text-theme-text" />
                      ) : (
                        <AiFillEyeInvisible className="text-2xl text-theme-text" />
                      )}
                    </button>
                  </div>
                  {formError.confirmNewPassword && (
                    <div className="form-eror">
                      {formError.confirmNewPassword}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <button
            type="button"
            onClick={handleCloseModal}
            className={`btn btn-danger `}
          >
            Close
          </button>
          <button
            type="button"
            onClick={handleSubmit}
            disabled={isLoading}
            className={`btn btn-primary ${
              isLoading
                ? "bg-red-500 border-red-500 opacity-50 disabled:pointer-events-none"
                : undefined
            }`}
          >
            {isLoading ? "Loading" : "Submit"}
          </button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ChangeUserPassword;
